import { HttpClient } from '@angular/common/http';
import { NetworkService } from 'src/app/core/services/network.service';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataAnalyticsService {

  private chatBoxSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(
    private networkService: NetworkService,
    private http: HttpClient
  ) { }

  toggleChatBox(value: boolean): void {
    this.chatBoxSubject.next(value);
  }

  getChatBoxStatus(): Observable<boolean> {
    return this.chatBoxSubject.asObservable();
  }

  clearSelectedDA() {
    sessionStorage.removeItem('selectedDACluster');
    sessionStorage.removeItem('selectedDAFactory');
    sessionStorage.removeItem('selectedDATimeFilter');
  }

  getFactorySummaryFunction(queryParams) {
    return this.networkService.httpReq('get', 'FactorySummaryFunction', queryParams, false, false)
      .pipe(map(res => {
        return res;
      }));
  }

  getRMPM(queryParams) {
    return this.networkService.httpReq('get', 'wastetrend/getrmpmcostcontribution', queryParams, false, false)
      .pipe(map(res => {
        return res && res.result;
      }));
  }

  getActualConsumption(reqParams) {
    return this.networkService.httpReq('get', 'wastetrend/getactualconsumption', reqParams, false, false)
      .pipe(map(res => res && res.result));
  }
  getCostContributionList(queryParams) {
    return this.networkService.httpReq('get', 'getWasteSplit', queryParams, false, false)
      .pipe(map(this.transformResult));
  }
  getCostContributionByABCD(queryParams) {
    return this.networkService.httpReq('get', 'wastetrend/getcostcontributionbyabcd', queryParams, false, false)
      .pipe(map(this.transformResult));
  }

  getDeliveredQuantity(queryParams) {
    return this.networkService.httpReq('get', 'wastetrend/getdistributedqtyandcostpercentage', queryParams, false, false)
      .pipe(map(this.transformResult));
  }

  getOEEAndChangeOver(queryParams) {
    return this.networkService.httpReq('get', 'wastetrend/getcostpercentageandoeeandchangeover', queryParams, false, false)
      .pipe(map(this.transformResult));
  }

  getInsight(url: string, queryParams: any) {
    return this.networkService.httpReq('get', url, queryParams, false, false)
      .pipe(map(this.transformResult));
  }

  getFactoryImage(url: string) {
    return this.networkService.httpReq('get-dfos', url, null, false, false).pipe(map(res => {
      if (res && res.image) {
        return res.image;
      }
    }));
  }

  insertBookmark(req) {
    return this.networkService.httpReq('post', 'insertbookmark', req);
  }

  getBookmark(queryParams) {
    return this.networkService.httpReq('get', 'getbookmark', queryParams, false, true)
      .pipe(map(this.transformResult));
  }

  deleteBookmark(req) {
    return this.networkService.httpReq('delete', 'deletebookmark?Id=' + req.Id);
  }

  getInsightSubscribers() {
    return this.http.get('assets/insights/subscribers.json');
  }

  /* Get comments*/
  getComments(queryParams) {
    return this.networkService.httpReq('get', 'getcommentswithreactions', queryParams, false, false)
      .pipe(map(this.transformResult));
  }

  /* post comment */
  postComment(body) {
    return this.networkService.httpReq('post', 'insertcomment', body, false, false)
      .pipe(map(this.transformResult));
  }
  // Get replies
  getReplies(queryParams) {
    return this.networkService.httpReq('get', 'getreplieswithreactions', queryParams, false, false)
      .pipe(map(this.transformResult));
  }

  /* post reply */
  postReply(body) {
    return this.networkService.httpReq('post', 'insertreply', body, false, false)
      .pipe(map(this.transformResult));
  }

  postReaction(body) {
    return this.networkService.httpReq('post', 'insertreaction', body, false, false)
      .pipe(map(this.transformResult));
  }

  deleteReaction(id: number, email: string) {
    return this.networkService.httpReq('delete', `deletemessagereaction?messageId=${id}&createdBy=${email}`, null, false, false)
      .pipe(map(this.transformResult));
  }

  getLatestDataRefreshDate() {
    return this.networkService.httpReq('get', 'wasteData/lastRefreshDate');
  }

  getUsersForMention(queryParams) {
    return this.networkService.httpReq('get', 'GetOrgLevelEmails', queryParams, false, false)
      .pipe(map(res => res.response));
  }

  transformResult(res) {
    if (res && (res.message === 'Ok' || res.message === 'ok')) {
      return res.result;
    }
  }
}
